import React, { useState } from "react";
import './style.css';

const ratingOptions = [
  { value: "all", label: "All Ratings" },
  { value: "8-10", label: "8-10" },
  { value: "6-8", label: "6-8" },
  { value: "4-6", label: "4-6" },
  { value: "0-4", label: "0-4" },
];

const sortOptions = [
  { value: "newest", label: "Newest" },
  { value: "oldest", label: "Oldest" },
  { value: "rating-high", label: "Highest Rated" },
  { value: "rating-low", label: "Lowest Rated" },
  { value: "title", label: "Title (A-Z)" },
];

export const FilterBar = ({ category, onFilterChange }) => {
  const [search, setSearch] = useState("");
  const [rating, setRating] = useState("all");
  const [sortBy, setSortBy] = useState("newest");

  // Call parent handler on any filter change
  React.useEffect(() => {
    onFilterChange({ search, rating, sortBy });
    // eslint-disable-next-line
  }, [search, rating, sortBy]);

  return (
    <div className="filterbar-container">
      <input
        className="filterbar-search"
        type="text"
        placeholder={`Search ${category === "tv" ? "TV shows" : category}...`}
        value={search}
        onChange={e => setSearch(e.target.value)}
      />
      <select
        className="filterbar-select"
        value={rating}
        onChange={e => setRating(e.target.value)}
      >
        {ratingOptions.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      <select
        className="filterbar-select"
        value={sortBy}
        onChange={e => setSortBy(e.target.value)}
      >
        {sortOptions.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    </div>
  );
};